import { render, staticRenderFns } from "./BaseSelect2.vue?vue&type=template&id=a747dd46&scoped=true"
import script from "./BaseSelect2.vue?vue&type=script&lang=js"
export * from "./BaseSelect2.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect2.vue?vue&type=style&index=0&id=a747dd46&prod&lang=scss&scoped=true"
import style1 from "./BaseSelect2.vue?vue&type=style&index=1&id=a747dd46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a747dd46",
  null
  
)

export default component.exports